/**
 * Formata o número para ficar com dois algarismos
 */
const formatTwoDigits: any = (num: number): string => {
    const digits: any = -2;

    return ('0' + num).slice(digits);
};

/**
 * Formata o número para ficar com tres algarismos
 */
const formatThreeDigits: any = (num: number): string => {
    const digits: any = -3;

    return ('0' + num).slice(digits);
};

/**
     * Método criado para que a data não sofra alteracão por
     * causa da UTC. Dessa forma, a conversão da data para JSON manterá exatamente
     * a mesma data informada incialmente na variavel.
*/
Date.prototype.getDateAsUTC = function (): Date {
    const year: any = this.getFullYear();
    const month: any = formatTwoDigits(this.getMonth() + 1);
    const date: any = formatTwoDigits(this.getDate());
    const hours: any = formatTwoDigits(this.getHours());
    const minutes: any = formatTwoDigits(this.getMinutes());
    const seconds: any = formatTwoDigits(this.getSeconds());
    const miliseconds: any = formatThreeDigits(this.getMilliseconds());

    return new Date(`${ year }-${ month }-${ date }T${ hours }:${ minutes }:${ seconds }.${ miliseconds }Z`);
};

Date.prototype.compareDate = function (otherDate: Date): number {
    const thisDt: any = new Date(this.getFullYear(), this.getMonth(), this.getDate());
    const otherDt: any = new Date(otherDate.getFullYear(), otherDate.getMonth(), otherDate.getDate());

    if (thisDt > otherDt) {
        return 1;
    }
    if (thisDt < otherDt) {
        return -1;
    }

    return 0;
};
